module.exports = __webpack_public_path__ + "static/media/422.9a57ffce.png";